/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';

interface Props {
  highlightedIndex: 0 | 1 | 2;
}

const Bar = styled.div<{ active: boolean }>`
  height: 12px;
  background-color: ${({ active }) => (active ? '#8CCDCD' : '#2F6472')};
  margin: 6px 0;
  border-radius: 4px;
  width: 70px;
  @media (max-width: 600px) {
      height: 8px;
      width: 55px;
      margin: 2px 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70px;
`;

const FloorIcon: React.FC<Props> = ({ highlightedIndex }) => {
  return (
    <Container>
      {[2, 1, 0].map((i) => (
        <Bar key={i} active={i === highlightedIndex} />
      ))}
    </Container>
  );
};

export default FloorIcon;
